import { render, staticRenderFns } from "./RfxBulkMessageList.vue?vue&type=template&id=1378e3ea"
import script from "./RfxBulkMessageList.vue?vue&type=script&lang=js"
export * from "./RfxBulkMessageList.vue?vue&type=script&lang=js"
import style0 from "./RfxBulkMessageList.vue?vue&type=style&index=0&id=1378e3ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports